/**
 * A–Z letter filter — active-state sync only.
 *
 * The tiles themselves are server-rendered links that apply the collection's
 * vendor filter (see sections/main-collection-product-grid.liquid), so Shopify
 * does the filtering and the pagination. This file deliberately does NOT filter
 * anything: the previous version hid <li>s on the current page with inline
 * styles, which is why the letters differed per page and why pagination kept
 * describing the unfiltered collection.
 *
 * All that is left to do is re-mark the active tile when facets.js swaps the
 * grid over AJAX and pushes a new URL, because the tiles live outside
 * #ProductGridContainer and so are not part of that swap.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-alpha-filter]');
  if (!root) return;

  var tiles = Array.prototype.slice.call(root.querySelectorAll('[data-alpha-letter]'));
  var headingEl = root.querySelector('[data-alpha-heading]');
  // Read the "nothing selected" label from the attribute rather than from the
  // heading's text: on a page that loads with a letter already applied the
  // heading holds that letter, not the label.
  var allLabel = root.getAttribute('data-all-label') || '';

  function activeLetterFromUrl() {
    var vendors;
    try {
      vendors = new URLSearchParams(window.location.search).getAll('filter.p.vendor');
    } catch (e) {
      return '';
    }
    if (!vendors.length) return '';

    var letter = '';
    for (var i = 0; i < vendors.length; i++) {
      var first = String(vendors[i]).trim().charAt(0).toUpperCase();
      if (!first) continue;
      if (!letter) letter = first;
      // Values spanning several letters mean the shopper used the Pattern
      // dropdown rather than a tile, so no tile should look selected.
      else if (letter !== first) return '';
    }
    return letter;
  }

  function sync() {
    var active = activeLetterFromUrl();
    tiles.forEach(function (tile) {
      var isActive = tile.getAttribute('data-alpha-letter') === active;
      tile.classList.toggle('alpha-btn--active', isActive);
      if (isActive) tile.setAttribute('aria-current', 'true');
      else tile.removeAttribute('aria-current');
    });
    if (headingEl && allLabel) headingEl.textContent = active || allLabel;
  }

  window.addEventListener('popstate', sync);

  // facets.js pushes state without firing popstate, so watch the grid it swaps.
  var container = document.getElementById('ProductGridContainer');
  if (container && 'MutationObserver' in window) {
    new MutationObserver(function () {
      window.requestAnimationFrame(sync);
    }).observe(container, { childList: true });
  }
})();
